import React from 'react';
// import './missions.css'
import 'mygame-components/src/Missions/missions.css'
import Loading from '../../Loading.js';
import { baseUrl,domain } from '../../../common/config.js';
import { apiService } from '../../../common/apiCallService';
import { Redirect } from 'react-router';
import MissionTable from './MissionTable';
import { processHoleCards, saveActivity } from '../../../common/commonService.js'
import * as actions from '../../../store/actions/index';
import { connect } from 'react-redux';
import { PositionLesson } from 'mygame-components';
import { createVirtualPageLoad, closeVirtualPage } from '../../../common/commonService'

class MissionHome extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hands: null,
            beginMissson: props.location.state.missionProps.plymission ? props.location.state.missionProps.plymission.missionStatus && true : false,
            greenHands: 0,
            redHands: 0,
            holeCards: null,
            playerData: null,
            handCount: null,
            loading: false,
            missionstartDate: props.location.state.missionProps.missionStatus != 'pre-start' ? props.location.state.missionProps.plymission.startDate : '',
            isExpanded: false,
            play: 'IDEAL',
            position: 'EARLY',
            selected: true,
            learnPositions: false,
            title: 'Mission',
            missionStatus: props.location.state.missionProps.missionStatus,
        }
        this.checkMissionIsStartedOrNot()
        // this.getStartingHands()
        // if (props.location.state.missionProps.callApi)
        //     this.getStartingHands()
        // else
        //     this.getMissionRecords()

    }

    componentDidMount() {
        createVirtualPageLoad("/mission")
    }

    componentWillUnmount() {
        closeVirtualPage()
    }

    checkMissionIsStartedOrNot = () => {
        let {accountName, gameType } = this.props.playerReports
        this.setState({ loading: true })
        apiService(baseUrl + '/missions/checkMissionIsStartedOrNot', {
            "accountName": accountName,
            'userType': localStorage.getItem('loggedInType'),
            'gameType': gameType
        }, (data) => {
            if (data.length > 0) {
                let mission = data[0].playerDetails.mission.find(obj => obj.status === 'Inprogress')
                    ? data[0].playerDetails.mission.find(obj => obj.status === 'Inprogress')
                    : data[0].playerDetails.mission.find(obj => obj.result === 'success')
                this.setState({
                    beginMissson: true,
                    missionstartDate: mission.startDate,
                    // missionStatus:mission.status
                })
            }
            this.getStartingHands()
        }, (data) => {
            this.setState({ loading: false })
        })
    }

    getStartingHands = () => {
        this.setState({ loading: true })
        apiService(baseUrl + '/appUser/getStartingHands', {
            "Strategy": this.props.playerReports.hitType
        }, (data) => {
            let hand = {}
            hand['Early'] = data[0]['Early']
            hand['Late'] = data[0]['Late']
            hand['Mid'] = data[0]['Mid']
            this.setState({ hands: hand })
            this.setState({ loading: false })
        }, (data) => {
            this.setState({ loading: false })
            if (data.status == 403) {
                this.props.setLogin()
            }
        })
    }
    getMissionRecords = (startDate = null) => {
        let { hitType, accountName, gameType} = this.props.playerReports
        this.state.loading = true
        this.forceUpdate()
        apiService(baseUrl + '/missions/getMissionRecords', {
            'accountName': accountName,
            'selectedType': hitType,
            'startDate': this.state.missionstartDate,
            'userType': localStorage.getItem('loggedInType'),
            'gameType':gameType
        }, (plydata) => {
            this.state.hands = this.props.location.state.missionProps.hand ? this.props.location.state.missionProps.hand : this.state.hands
            new Promise((resolve, reject) => {
                processHoleCards(plydata, this.props.location.state.missionProps.hand, this.state.hitType, 'Early')
                    .then((tableData) => {
                        let handCount = tableData[0]
                        let redHands = 0
                        let greenHands = 0
                        Object.keys(handCount).forEach(function (key) {
                            greenHands = greenHands + handCount[key].played + handCount[key].progressplayed
                            redHands = redHands + handCount[key].notPlayed
                        });
                        this.state.totalHands = greenHands + redHands
                        this.state.greenHands = greenHands
                        this.state.redHands = redHands
                        this.state.holeCards = tableData[1]
                        this.state.handCount = tableData[0]
                        this.state.playerData = tableData[2]
                        this.state.loading = false
                        this.forceUpdate()
                    })
                    .catch((err) => {
                        this.setState({ loading: false })
                        reject(err)
                    })
            })
        }, (data) => {
            this.setState({ loading: false })
        })
    }

    learnPositions = () => {
        window.scrollTo(0, 0);
        this.setState({ learnPositions: !this.state.learnPositions })
    }
    minimiseMission = () => {
        let summaryInfo = this.props.playerReports.summaryInfo[0]
        saveActivity({
            hit_page: 'MissionTooManyHands', hit_type: 'ReportCardMinimiseMission',
            hit_attribute1: summaryInfo.points,
            hit_attribute2: summaryInfo.medal,
        })
        this.props.history.goBack()
    }
    goBack = () =>{
        this.props.history.goBack()
    }
    render() {
        let { mission, hitType, accountName, gameType ,summaryInfo} = this.props.playerReports
        this.props.setHeaderTitle(this.state.title)
        const { isExpanded, learnPositions } = this.state
            , objective = [`Study the ideal play charts below. Begin your mission & try to play 50 hands in the green.`,
            `This mission counts hands where you enter the pot first and you raise.`,
            `Keep track of your play on your ‘Actual Hands’ & watch your game improve.`,
            `The counter below only counts hands you raised as the first person in the pot.`,
            `Raise 50 hands as first person in the pot to complete the mission.`]
        // , { objective, minMissionCompletion } = this.props.location.state.missionProps.plymission
        return (
            <div>
                {this.state.loginRedirect && (<Redirect to={'/'} />)}
                {this.state.loading ? <Loading /> : null}
                <div className={`${learnPositions && `displayUptoTabDeskMissionObj`}`} style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row" style={{ paddingTop: '21px', paddingLeft: '15px' }}>
                            <div className="col-xs-11 col-sm-11 col-md-9 col-lg-9 missionTitle">
                                {mission.name} Mission
                    </div>
                            <div className="col-xs-1 col-sm-1 col-md-3 col-lg-3" style={{paddingLeft:'0' }}>
                                <button className="missionbtn minimizeMission displayForDesk" onClick={this.minimiseMission}> MINIMIZE MISSION</button>
                                <span className='displayUptoTab' style={{ float: 'right', margin: '0 auto' }} onClick={this.minimiseMission}>
                                    <i className="fa fa-times missioncross"></i>
                                </span>

                            </div>
                        </div>
                    </div>
                    {isExpanded
                        ? <div className="container" style={{paddingTop:'11px'}}>
                            <div className="missionCompletionPer">
                                Complete & improve up to 25%
                            </div>
                            <ul className="objective" style={{ marginBottom: '6px' }}>
                                {objective.map((point, index) => {
                                    return <li key={index} style={{ paddingBottom: '8px' }}>{point}</li>
                                })}
                            </ul>
                            <div className="row seeHideObjective">
                                <span className="seeObjective" onClick={() => this.setState({ isExpanded: !isExpanded })}>
                                    Hide Objectives <i className="fa fa-angle-up"></i>
                                </span>
                            </div>
                        </div>
                        : <div className="container">
                            <div className="row seeHideObjective">
                                <div className="seeObjective" onClick={() => this.setState({ isExpanded: !isExpanded })}>
                                    See Objectives <i className="fa fa-angle-down"></i>
                                </div>
                            </div>
                        </div>
                    }
                    <div className='displayUptoMob' style={{ border: '0.5px solid #eee' }} />
                </div>

                <div className="container">
                    <div className="row" style={{ margin: '0' }}>
                        {this.state.hands &&
                            <span className={this.state.learnPositions ? 'displayForDesk' : 'inlineDisplay'}>
                                <MissionTable
                                    hands={this.state.hands}
                                    beginMissson={this.state.beginMissson}
                                    selectedType={hitType}
                                    missionName={mission.name}
                                    accountName={accountName}
                                    medal={summaryInfo[0].medal}
                                    points={summaryInfo[0].points}
                                    result={this.props.location.state.missionProps.result}
                                    missionstartDate={this.state.missionstartDate}
                                    learnPositions={this.learnPositions}
                                    missionStatus={this.state.missionStatus}
                                    goBack={this.goBack}
                                    gameType={gameType}
                                />
                            </span>
                        }
                        <span className={!this.state.learnPositions ? 'displayForDesk' : 'inlineDisplay'}>
                            <PositionLesson
                                domain={domain}
                                learnPositions={this.state.learnPositions}
                                learnPositionsFun={this.learnPositions} />
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        playerReports: state.multipleReportCards.playerReports
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MissionHome);



/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/Missions/MissionHome.js
 **/